import {
  REQUEST_CAMPAIGNSTATISTICS,
  REQUEST_CAMPAIGNSTATISTICS_DONE,
  CampaignStatisticsActions
} from "./types";
import { CampaignStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchCampaignStatistics(): CampaignStatisticsActions {
  return {
    type: REQUEST_CAMPAIGNSTATISTICS,
    payload: []
  };
}

function fetchCampaignStatisticsDone(
  CampaignStatistics: ReadonlyArray<CampaignStatistics>
): CampaignStatisticsActions {
  return {
    type: REQUEST_CAMPAIGNSTATISTICS_DONE,
    payload: CampaignStatistics
  };
}

/* Thunks goes here */
export const thunkFetchCampaignStatistics = (campaignDate: Date) => async (
  dispatch: any
) => {
  try {
    dispatch(fetchCampaignStatistics());
    const result = await StatisticsApi.getCampaignStatistics(campaignDate);

    if (isOk(result)) {
      dispatch(fetchCampaignStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchCampaignStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
